import axios from "axios";
import { transactionID } from "./helpers";

export const baseAPI = axios.create({
  baseURL: 'https://www.pagtel.com.br/Hub360Correios/'
});

export const CIELO_ENVIRONMENT = "PRD";

export const apiCielo = axios.create({
  baseURL: CIELO_ENVIRONMENT === "PRD" ? 'https://mpi.braspag.com.br' : "https://mpisandbox.braspag.com.br"
});

export const apiConfigsCielo = axios.create({
  baseURL: 'https://geostag.cardinalcommerce.com/DeviceFingerprintWeb/',
});

export const apiConfigsCieloInitializer = axios.create({
  baseURL: 'https://centinelapi.cardinalcommerce.com/',
});

export const apiConfigsCieloLog = axios.create({
  baseURL: 'https://writer.cardinalcommerce.com/',
});

export const apiHub360 = axios.create({
  baseURL: 'https://www.pagtel.com.br/Hub360Correios',
});

export const hub360Client = {
  authenticationInCielo: (body, token) =>
    apiHub360.post('https://www.pagtel.com.br/Hub360Correios/v1/cieloAuthorize', { // TODO: Change this url
      ...body,
      transactionId: transactionID('GI'),
    }, {
      headers: {
        authorization: `Bearer ${token}`
      }
    }),
}

export const validatePhone = async (mvnoName, number) => {
  return await axios.post(
    `https://www.pagtel.com.br/Surf360/auth/v1/validatePhone`,
    {
      Network: mvnoName, //Santander
      MSISDN: "55" + number, //Numero a ser verificado
      Version: "0.1",
      UniqueID: "xxxxx",
      OS: "Navegador",
      SystemVersion: "0.1",
      Model: "PC",
      Source: "Site",
    }
  );
};

export const GoPortin = async (
  transaction,
  newNumber,
  oldNumber,
  cpf,
  operator,
  portinDate,
  name,
  token
) => {
  return await axios.post(
    `https://www.pagtel.com.br/Surf360/v2/submitPortin`,
    {
      transactionId: transaction,
      MSISDN: "55" + newNumber,
      PMSISDN: "55" + oldNumber,
      CPF: cpf,
      operatorCode: operator,
      portinDate: portinDate,
      name: name,
    },
    { headers: { Authorization: "Bearer " + token } }
  );
};
